import React, { useState, useEffect } from 'react';
import { Dropdown, Button } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useApp } from '../../context/AppContext';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ onLanguageChange }) => {
    const { i18n } = useTranslation();
    const { changeLanguage: updateLanguage } = useApp();
    const [currentLang, setCurrentLang] = useState(i18n.language);

    useEffect(() => {
        // Update current language when i18n language changes
        const handleLanguageChange = (lng) => {
            setCurrentLang(lng);
        };

        i18n.on('languageChanged', handleLanguageChange);

        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [i18n]);

    const languages = [
        { code: 'en', name: 'English', flag: '🇬🇧' },
        { code: 'ar', name: 'العربية', flag: '🇮🇶' },
        { code: 'ku', name: 'کوردی', flag: '🇮🇶' }
    ];

    const changeLanguage = async (code) => {
        // Update language via AppContext (which handles backend sync)
        await updateLanguage(code);

        // Call parent callback if provided
        if (onLanguageChange) {
            onLanguageChange(code);
        }
    };

    const items = languages.map(lang => ({
        key: lang.code,
        label: (
            <div onClick={() => changeLanguage(lang.code)} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 20 }}>{lang.flag}</span>
                <span>{lang.name}</span>
            </div>
        )
    }));

    const currentLanguage = languages.find(lang => lang.code === currentLang) || languages[0];
    const isRTL = currentLang === 'ar' || currentLang === 'ku';

    return (
        <Dropdown menu={{ items }} placement={isRTL ? 'bottomLeft' : 'bottomRight'} className="language-switcher">
            <Button icon={<GlobalOutlined />}>
                <span className="language-name">{currentLanguage.name}</span>
            </Button>
        </Dropdown>
    );
};

export default LanguageSwitcher;
